import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { inLastStep } from '../../selectors/ui';
import { getOrderTotal } from '../../selectors/cart';
import { GoogleAnalytics4 } from './GoogleAnalytics4';

export class GoogleFloodlight extends GoogleAnalytics4 {
    constructor(props) {
        super(props);

        if (props.config?.floodlight_id) {
            // subscribe to hooks
            this.props.addReservationCompleteHook(this.onReservationComplete);
        }
    }

    onReservationComplete = () => {
        const reservationSessionKey = `Floodlight_${this.props.config.floodlight_id}_onReservationComplete_${this.props.confirmationNumber}`;

        const sent = sessionStorage.getItem(reservationSessionKey);
        if (!sent) {
            // purchase event
            this.reportWholeReservationEvent('purchase', {
                transaction_id: this.props.confirmationNumber,
            });
            sessionStorage.setItem(reservationSessionKey,'1');
        }
    }
}

const mapStateToProps = state => {
    return {
        payments: state.payment.payments,
        confirmationNumber: state.reservation.confirmation_number,
        inLastStep: inLastStep(state),
        currency: state.reservation.currency || 'USD',
        orderTotal: getOrderTotal(state)?.amount ?? 0,
        tickets: state.tickets.tickets,
        productSales: state.productSales.products,
        bundleSales: state.bundleSales.bundles,
    }
}

const mapDispatchToProps = dispatch => {
    const actions = {};
    Object.keys(hookActions).forEach(hookActionName => {
        actions[hookActionName] = hookActions[hookActionName];
    });
    return bindActionCreators(actions, dispatch);
}

GoogleFloodlight.propTypes = {
    config: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleFloodlight)
